import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X, ChevronDown } from "lucide-react";
import Logo from "./Logo";
import { LOAN_PRODUCTS } from "../lib/api";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);

  const linkClass = ({ isActive }) =>
    `px-3 py-2 text-sm font-medium transition-colors ${
      isActive ? "text-[#0052FF]" : "text-[#09090b] hover:text-[#0052FF]"
    }`;

  return (
    <header className="lj-glass sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center" data-testid="navbar-home-link">
            <Logo size={40} withWordmark />
          </Link>

          <nav className="hidden lg:flex items-center gap-1">
            <NavLink to="/" end className={linkClass} data-testid="nav-home">Home</NavLink>
            <NavLink to="/about" className={linkClass} data-testid="nav-about">About</NavLink>
            <div
              className="relative"
              onMouseEnter={() => setServicesOpen(true)}
              onMouseLeave={() => setServicesOpen(false)}
            >
              <button
                className="px-3 py-2 text-sm font-medium text-[#09090b] hover:text-[#0052FF] flex items-center gap-1"
                data-testid="nav-services"
              >
                Loan Services <ChevronDown size={14} />
              </button>
              {servicesOpen && (
                <div className="absolute left-0 top-full mt-1 w-72 bg-white border border-[#E4E4E7] rounded-xl shadow-lg p-2">
                  <Link to="/services" className="block px-3 py-2 text-sm font-semibold text-[#06152D] hover:bg-[#EBF2FF] rounded-lg" data-testid="nav-services-all">
                    All Loan Services →
                  </Link>
                  <div className="my-1 h-px bg-[#E4E4E7]" />
                  {LOAN_PRODUCTS.map((p) => (
                    <Link
                      key={p.slug}
                      to={`/services/${p.slug}`}
                      className="block px-3 py-2 text-sm text-[#09090b] hover:bg-[#EBF2FF] rounded-lg"
                      data-testid={`nav-service-${p.slug}`}
                    >
                      {p.label}
                    </Link>
                  ))}
                </div>
              )}
            </div>
            <NavLink to="/emi-calculator" className={linkClass} data-testid="nav-emi">EMI Calculator</NavLink>
            <NavLink to="/contact" className={linkClass} data-testid="nav-contact">Contact</NavLink>
          </nav>

          <div className="hidden lg:flex items-center gap-3">
            <Link
              to="/admin/login"
              className="text-sm font-medium text-[#52525B] hover:text-[#06152D]"
              data-testid="nav-admin-login"
            >
              Admin Login
            </Link>
            <Link
              to="/apply"
              className="bg-[#0052FF] hover:bg-[#003FCC] text-white text-sm font-semibold px-5 py-2.5 rounded-full transition-colors lj-focus"
              data-testid="nav-apply-cta"
            >
              Apply Online
            </Link>
          </div>

          <button
            onClick={() => setOpen(!open)}
            className="lg:hidden p-2 text-[#06152D]"
            data-testid="nav-mobile-toggle"
            aria-label="Toggle menu"
          >
            {open ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-[#E4E4E7] bg-white">
          <div className="px-4 py-3 space-y-1">
            {[
              ["/", "Home"], ["/about", "About"], ["/services", "All Loan Services"],
              ["/emi-calculator", "EMI Calculator"],
              ["/apply", "Apply Online"], ["/contact", "Contact"], ["/faq", "FAQ"],
              ["/admin/login", "Admin Login"],
            ].map(([to, label]) => (
              <Link
                key={to}
                to={to}
                onClick={() => setOpen(false)}
                className="block px-3 py-2 text-sm font-medium text-[#09090b] hover:bg-[#EBF2FF] rounded-lg"
                data-testid={`mobile-nav-${to.replace(/[/]/g, "-")}`}
              >
                {label}
              </Link>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
